<div class="score-line-container">
    <div class="line-chart-wrapper">
        <div class="line-chart text-center">
            <svg id="performance-score-line-chart" *ngIf="chartSetupDone" (mouseout)="disableTooltip()">
                <g *ngFor="let group of dataGroups; let $index = index" (mouseover)="setTooltip($event, group)">
                    <path [attr.d]="groupPath(group)" [attr.fill]="groupPathFillColor(group)"></path>
                    <path class="top-line" [attr.d]="groupLine(group)" [attr.stroke]="groupLineFillColor(group)"></path>
                    <circle *ngIf="$index === dataGroups.length - 1"
                            [attr.cx]="chart.baseX + group.end.x + 1"
                            [attr.cy]="chart.baseY + group.end.y"
                            [attr.r]="3"
                            fill="none"
                            [attr.stroke]="groupLineFillColor(group)"
                            stroke-width="3">
                    </circle>
                </g>
                <g *ngFor="let group of dataGroups; let $index = index;" (mouseover)="setTooltip($event, group)">
                    <circle *ngIf="$index === 0 && !group.start.isBreakPoint"
                            [attr.cx]="chart.baseX + group.start.x + 1"
                            [attr.cy]="chart.baseY + group.start.y"
                            [attr.r]="2"
                            fill="none"
                            [attr.stroke]="groupLineFillColor(group)"
                            stroke-width="2"></circle>
                    <circle *ngIf="$index !== dataGroups.length - 1 && !group.end.isBreakPoint"
                            [attr.cx]="chart.baseX + group.end.x + 1"
                            [attr.cy]="chart.baseY + group.end.y"
                            [attr.r]="2"
                            fill="none"
                            [attr.stroke]="groupLineFillColor(group)"
                            stroke-width="2"></circle>
                </g>

                <ng-container *ngFor="let milestone of milestonesToDisplay">
                    <g *ngIf="milestone.x != null">
                        <a class="milestoneLink"
                            [attr.href]="milestone.link"
                            target="_blank">
                            <text
                                [attr.x]="milestone.x"
                                [attr.data-x]="milestone.x"
                                y="14"
                                class="milestoneText">{{milestone.text}}
                            </text>
                        </a>
                        <line
                            class="milestoneLine" y1="35" y2="155"
                            stroke-dasharray="5,5"
                            [attr.x1]="milestone.x"
                            [attr.x2]="milestone.x"
                        ></line>
                    </g>
                </ng-container>
            </svg>
            <div class="line-chart-header mt-2" [style]="headerStyle">
                <span class="text-bold mr-1" translate>Timeline</span>
                <span class="fas fa-question-circle" [ngbTooltip]="'Last 8 Performance Scans Scores' | translate" tooltipClass="text-ellipsis" aria-hidden="true"></span>
            </div>
            <div class="score-line-chart-tooltips" [style]="tooltipStyle">
                <div class="font-weight-bold">{{tooltip.score * 100 | monNumber}}</div>
                <div class="text-grey text-nowrap">{{tooltip.time}}</div>
            </div>
        </div>
    </div>
</div>
